<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { title, count } = defineProps<{ title: string; count: number }>();
</script>

<template>
  <div class="found-item-group">
    <div class="found-item-group__header">
      <Text font="body-medium-18">{{ title }}</Text>
      <Text font="body-regular-12" color="secondary">{{ `${$t("Цветомоделей")}: ${count}` }}</Text>
    </div>
    <div class="found-item-group__content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
  .found-item-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .found-item-group__header {
    display: flex;
    flex-direction: column;
  }

  .found-item-group__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>
